module.exports = __webpack_public_path__ + "static/media/TYC_Reventa.457c7d65.pdf";